import { render, staticRenderFns } from "./Mdfe.vue?vue&type=template&id=448eeb71&scoped=true&"
import script from "./Mdfe.vue?vue&type=script&lang=js&"
export * from "./Mdfe.vue?vue&type=script&lang=js&"
import style0 from "./Mdfe.vue?vue&type=style&index=0&id=448eeb71&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448eeb71",
  null
  
)

export default component.exports